import { Variable, Div, Span, Button, Select, not, Option } from 'alkali'
import Dialog from '../generic/DialogAlkali'
import TermInput from '../generic/TermInput'

export class SelectionsModificationDialog extends Dialog('.selections-modification-dialog') {
	protected selectedTerm: Variable<any>
	get defaults() {
		return {
			head: {
				titleText: 'Modifying Question/Selections',
			},
			foot: {}
		}
	}
	ready(properties) {
		this.body.append(
			Div([`
				You are modifying a favorite/saved question and selections. You can edit the existing favorite question,
				and any changes you make will be automatically saved to this saved question. Or you you can copy this question
				and selections for a new question which will not affect the original favorite`
			]),
		)
		this.footer.rightControls.append([
			Button('Edit Saved Question (with auto-save)', {
				onclick: () => {
					this.edit()
					this.hide()
				}
			}),
			Button('Copy Saved Question', {
				onclick: () => {
					this.copy()
					this.hide()
				}
			})
		])
	}
}